module.exports = __webpack_public_path__ + "img/sankaku_86_red.8c6d9540.png";